export const korektivniAktivnostiData =
    [
        {
            id: "1", ime: "Неприменливо, ова е прва година како аплицираме за сертификација"
        },
        {
            id: "2", ime: "Нема корективни активности "
        }
    ]